import instanceService from "./instanceService";

export const manageServiceInstance = new instanceService(process.env.MIX_VUE_APP_HTTP, 'Manage');
export const memberServiceInstance = new instanceService(process.env.MIX_VUE_APP_HTTP, 'Member');
export const adminServiceInstance = new instanceService(process.env.MIX_VUE_APP_HTTP, 'Admin');
